import Image from 'next/legacy/image'
import styled from 'styled-components'

import { colors, fontWeights } from '@/styles'
import { ArrowRightIconBlue } from '@/components/icons'

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 24px;
  background-color: ${colors.grey96};
  margin-right: 12px;
`

const InfoContainer = styled.div<{ wrapBuildingName?: boolean }>`
  display: flex;
  justify-content: ${props =>
    props.wrapBuildingName ? 'center' : 'space-between'};
  align-items: ${props => (props.wrapBuildingName ? 'flex-start' : 'center')};
  width: 100%;
  flex-direction: ${props => (props.wrapBuildingName ? 'column' : 'row')};
`
const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
`
const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`

const EnterAddressContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  &:hover {
    opacity: 0.5;
    background: ${colors.lightGrey};
  }
`

const Name = styled.h2`
  color: ${colors.grey24};
  font-size: 14px;
  font-weight: ${fontWeights.regular};
  font-family: 'Inter';
  letter-spacing: -0.38px;
  line-height: 24px;
  margin: 0;
`
const StyledArrowRightBlue = styled(ArrowRightIconBlue)`
  width: 12px;
  height: 12px;
  margin-left: 4px;
`
const Address = styled.p`
  color: ${colors.regular};
  font-family: 'Inter';
  font-size: 16px;
  font-weight: ${fontWeights.medium};
  letter-spacing: -0.39px;
  margin: 0;
`
const EnterAddress = styled.p`
  color: ${colors.link};
  font-family: 'Inter';
  font-size: 14px;
  font-weight: ${fontWeights.medium};
  margin: 0;
`
const CityStateCountry = styled.p`
  color: ${colors.grey24};
  font-family: 'Inter';
  font-size: 14px;
  line-height: 24px;
  margin: 0;
`
const BuildingImage = styled(Image)`
  width: 80px;
  height: 60px;
  object-fit: cover;
  border-radius: 4px;
`
const markStyle = {
  background: 'none',
  color: colors.secondary
}

export {
  Name,
  Address,
  BuildingImage,
  markStyle,
  IconContainer,
  InfoContainer,
  AddressContainer,
  Container,
  CityStateCountry,
  StyledArrowRightBlue,
  EnterAddress,
  EnterAddressContainer
}
